// English resource bundle — the source of truth for every string key that
// has a matching Arabic entry. When you add a new page's Arabic copy, mirror
// the shape of the corresponding block below inside /src/i18n/ar/*.js.
//
// Keep this file namespaced by page/section so that per-page Arabic can be
// dropped in one file at a time.
export const en = {
  brand: {
    name: "Wafa Solutions LLC",
    tagline: "Software that runs your business, not the other way round.",
  },
  nav: {
    whoWeServe: "Who We Serve",
    services: "Services",
    solutions: "Solutions",
    products: "Products",
    meyar: "Meyar",
    work: "Work",
    tools: "Tools",
    company: "Company",
    getQuote: "Get a Free Quote",
  },
  contact: {
    email: "support@wafa.om",
  },
  announcement: {
    text: "Free: see where you stand on Oman's data protection law. Takes 3 minutes.",
    cta: "Check now →",
  },
};
